// REPLACE-ME: replace with correct editor metadata!
// See the 'data connection' bullet in https://github.com/wix-private/wix-ui-santa/wiki/Editor-parts-for-viewer-components#panels
// For all available options see https://github.com/wix-private/santa-editor/blob/1993f2792ab14acdd20a54a804564ea5c0d9572d/santa-editor/packages/rEditor/src/main/app/APISections/singleCompHandlers/componentsMetaData.js#L28
export const SelectionTagsListMetadata = {
  allowConnectToDB: true,
  verticallyResizable: false,
};
